import { Breadcrumbs } from '@/components/Breadcrumbs';
import { UserMenu } from '@/components/sidebar/UserMenu';
import { Separator } from '@/components/ui/separator';
import { SidebarTrigger } from '@/components/ui/sidebar';
import type { ReactNode } from 'react';

interface TopBarProps {
  /**
   * Page-context slot. Defaults to the route-handle-driven `Breadcrumbs`
   * component; pages that want to override (e.g. a tabbed sub-page with
   * a custom heading) can pass their own.
   */
  children?: ReactNode;
}

/**
 * Sticky top bar that pairs with the sidebar layout. Mounts the sidebar
 * collapse trigger, the breadcrumb trail (or a page-supplied override),
 * and the account menu on the right. The theme picker lives inside the
 * account menu's dropdown — see `UserMenu` + `ThemeMenuItems`.
 */
export function TopBar({ children }: TopBarProps) {
  return (
    <header className="sticky top-0 z-30 flex h-12 shrink-0 items-center gap-2 border-b bg-background px-4">
      <SidebarTrigger className="-ml-2" />
      <Separator orientation="vertical" className="mr-2 h-5" />
      <div className="flex flex-1 items-center gap-2 overflow-hidden text-sm">
        {children ?? <Breadcrumbs />}
      </div>
      <div className="flex items-center gap-1">
        <UserMenu />
      </div>
    </header>
  );
}
